import type { ServerDraft } from "@/types";

export function createEmptyServerDraft(): ServerDraft {
  return {
    id: "",
    name: "",
    host: "",
    user: "root",
    port: "22",
  };
}
